var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imposto)?_c('h6',{staticClass:"titulo-inaplicabilidade"},[_vm._v("Inaplicabilidade da "+_vm._s(_vm.imposto))]):_vm._e(),_c('span',{staticClass:"inaplicabilidade",domProps:{"innerHTML":_vm._s(_vm.textoNegrito)}})])}
var staticRenderFns = []

export { render, staticRenderFns }